import { isValidEmailAddress, fadeOutNotifications } from '../functions';

/*$(document).ready(function() {

	var isLoadingNewsletter = false;
    $(document).on('click', '#newsletter-btn', function() {

        if (isLoadingNewsletter) {
            console.log('is loading...');
            return false;
        }

		isLoadingNewsletter = true;

		$('.newsletter-notifications').html('');

		var values='';
		values+='&email=' + $('#newsletter-email').val();
		values+='&_token=' + $('#_token_newsletter').val();

		$.ajax({
			type: "POST",
			url: baseURL + "/newsletter/save",
			dataType: "JSON",
			data: values,
			success: function(response) {
				isLoadingNewsletter = false;

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							if (errorHtml != '') {
								errorHtml += '<br />';
							}
							errorHtml += `${response.errors[errorKey][error]}`;
						}
					}
					$('.newsletter-notifications').html('<div class="errors-wrapper"><p>'+errorHtml+'</p></div>');
					fadeOutNotifications('.newsletter-notifications .errors-wrapper');
					return false;
				}

				if (response.status == 1) {

					$('.newsletter-notifications').html('<div class="success-wrapper"><p>'+response.message+'</p></div>');
					fadeOutNotifications('.newsletter-notifications .success-wrapper');

					$('#newsletter-email').val('');

					return false;
				}

				$('.newsletter-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
				fadeOutNotifications('.newsletter-notifications .errors-wrapper');
				return false;
			},
			error(error) {
                isLoadingNewsletter = false;
            }
		});

		return false;

    });
});*/

var isLoadingNewsletter = false;
$(document).on('click', '#send-newsletter-btn', function(e) {
	e.preventDefault();

	if (isLoadingNewsletter) { return false; }

	$('#newsletter-form').find('.form-control').removeClass('is-invalid');
	$('#newsletter-terms-and-condition').parent().removeClass('has-error');
	$('#newsletter-response').html('');
	var errors = false;

	if ($('#newsletter-name').val() == '') {
		$('#newsletter-name').addClass('is-invalid');
		errors = true;
	}
	if ($('#newsletter-email').val() == '') {
		$('#newsletter-email').addClass('is-invalid');
		$('#newsletter-response').html('<div class="alert alert-danger" role="alert">Va rugam completati adresa de email!</div>');
		errors = true;
	}

	if (!$('#newsletter-terms-and-condition').is(":checked")) {
		$('#newsletter-terms-and-condition').parent().addClass('has-error');
		$('#newsletter-response').html('<div class="alert alert-danger" role="alert">Te rugăm să accepți Politica de confidențialitate!</div>');
		errors = true;
	}

	if (errors) {
		return false;
	}

	isLoadingNewsletter = true;
	let element = this;
	$(element).find('i').show();

	var values = '_token=' + $('#newsletter-token').val();
	values += '&name=' + $('#newsletter-name').val();
	values += '&email=' + $('#newsletter-email').val();
	$.ajax({
        type: "POST",
        url: baseURL + "/newsletter/save",
        data: values,
        success: function(response) {
			isLoadingNewsletter = false;
			$(element).find('i').hide();

			if (response.status == 0) {
				var errorHtml = '';
				for(var errorKey in response.errors) {
					if(!response.errors.hasOwnProperty(errorKey)) continue;
					for(var error in response.errors[errorKey]) {
						$("#"+errorKey).addClass('is-invalid');
						errorHtml += response.errors[errorKey][error] + '<br>';
					}
				}

				$('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+errorHtml+'</div>');
				return false;
			}

			if (response.status == 1) {

				$('#newsletter-name').val('');
				$('#newsletter-email').val('');
				$('#newsletter-terms-and-condition').prop("checked", false);
				$(".newsletter-section .checkmark").toggleClass("fa-check-square").toggleClass("fa-square");
				$('#newsletter-response').html('<div class="alert alert-success" role="alert">'+response.message+'</div>');

				/*if (cookies_advertisement == 1 || cookies_social == 1) {
					fbq('track', 'Lead');
				}*/
				return;
			}

			$('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+response.errors+'</div>');
        },
		error(error) {
			isLoadingNewsletter = false;
			$(element).find('i').hide();
		}
    });
});



// WEBPACK FOOTER //
// ./resources/js/modules/newsletter.js